import { render, staticRenderFns } from "./ScalaCell.vue?vue&type=template&id=0e96e570&"
import script from "./ScalaCell.vue?vue&type=script&lang=js&"
export * from "./ScalaCell.vue?vue&type=script&lang=js&"
import style0 from "./ScalaCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports